<template>
  <div class="mobile">
    <v-row>
      <v-col cols="10" offset="1">
        <p class="text-h3 text-center">Sorry, Expericoder is not available on mobile devices.</p>
      </v-col>
    </v-row>
  </div>
</template>

<script>

export default {
  name: 'Mobile',
  
}
</script>
